import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Header = styled.header``;

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const IllustrationContainer = styled.div<{ $hasImage: boolean }>`
  align-self: center;
  position: relative;
  display: block;

  ${({ theme, $hasImage }) =>
    theme.isMobile &&
    $hasImage &&
    css`
      display: none;
    `};
`;

export const ImageContainer = styled.div<{ $hasImage: boolean }>`
  position: relative;
  width: 8rem;
  height: 8rem;

  border-radius: ${({ theme }) => theme.spacing(3)};
  overflow: hidden;

  font-size: 4rem;
`;

export const ColorDot = styled.span<{ $color: string }>`
  position: absolute;
  bottom: ${({ theme }) => `-${theme.spacing(0.75)}`};
  right: ${({ theme }) => `-${theme.spacing(0.75)}`};

  display: block;
  height: 1.2rem;
  width: 1.2rem;

  border: ${({ theme }) =>
    `${theme.spacing(0.5)} solid ${theme.palette.background.default};`};
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(4)};

  width: 100%;
`;

export const Content = styled.div<{ $completed: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  justify-content: space-between;

  color: ${({ theme, $completed }) =>
    $completed ? theme.palette.text.secondary : 'inherit'};
`;

export const ContentHeader = styled.div``;

export const DescriptionContainer = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
`;

export const Anchor = styled.a`
  display: inline-block;
  max-width: 20rem;

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    text-decoration: underline;
  }
`;

export const MetaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ theme }) => (theme.isMobile ? 'column' : 'row')};
  gap: ${({ theme }) => theme.spacing(theme.isMobile ? 1 : 4)};
  min-width: 0;
`;

export const MetaItem = styled.span<{
  $hideMobile?: boolean;
  $noOverflow?: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ theme, $noOverflow }) =>
    theme.isMobile &&
    !$noOverflow &&
    css`
      min-width: 0;
      overflow: hidden;

      text-overflow: ellipsis;
    `};

  ${({ theme, $hideMobile }) =>
    theme.isMobile &&
    $hideMobile &&
    css`
      display: none;
    `};
`;

export const MetaLabel = styled.span`
  ${({ theme }) =>
    theme.isMobile &&
    css`
      min-width: 0;
      overflow: hidden;

      white-space: nowrap;
      text-overflow: ellipsis;
    `};
`;

export const IconContainer = styled.span`
  font-size: 1.2rem;
  line-height: 62.5%;
`;
